import impReducer from "./impReducer";
import { combineReducers } from "redux";
const rootReducer = combineReducers({
  impReducer,
});

export default rootReducer;